import VideoCard from './VideoCard';

export default VideoCard;
export * from './VideoCard';
